import React from 'react';
import styled from 'styled-components'

export default function DateBeauty({startsDay,startsMonth, starsHour, big = false }) {
    return (
        <DateContainer big={big}>
            <DateDay big={big}>{startsDay}</DateDay>
            <DateMonth big={big}>{startsMonth}</DateMonth>
            <DateHour big={big}>{starsHour}</DateHour>
        </DateContainer>

    )
}


const DateDay = styled.div`
    color: #FA9F63;
    text-align: center;
    font-size: ${props => props.big ? 36 : 22}px;
    font-weight: bold;
`

const DateMonth = styled.div`
    color: white;
    text-align: center;
    font-size: ${props => props.big ? 18 : 12}px;
    padding-top: ${props => props.big ? 4 : 2}px;
`

const DateHour = styled.div`
    padding-top: ${props => props.big ? 8 : 4}px;
    font-size: 12px;
  text-align: center;
`

const DateContainer = styled.div`
    margin-left: 12px;
    padding-top: 4px;

`
